export default "__VITE_ASSET__UUyBTNL9__"